export enum ConfigId {
    business = 'business',
    private = 'private',
}
